﻿import React, { useState, useEffect } from 'react';
import { HelpDocument } from '../models/help-document';
import { FieldUpdate } from '../models/field-update';
import { CrudFunctions } from '../utilities/crud-functions';
import { EditorConstants } from '../store/editor-constants';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { DocumentKeyWord } from '../models/Documentation/documentation-key-word';
import { ModalMessageType } from '../models/enums';
import DmaFooter from './DmaFooter';

import HtmlEditor, {
    TableContextMenu,
    TableResizing,
    Mention,
    Toolbar, MediaResizing, Item
} from 'devextreme-react/html-editor';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';

//temp
const mentionsList = [
    { id: 1, name: "Red", rgb: "FF0000" },
    { id: 2, name: "Green", rgb: "00FF00" },
    { id: 3, name: "Blue", rgb: "0000FF" },
    { id: 4, name: "Black", rgb: "000000" },
];

export default function DocumentationEditor() {
    const [loadPanelVisible, setLoadPanelVisible] =
        useState<boolean>(true);

    const [helpDocument, setHelpDocument] =
        useState<HelpDocument>();

    const [keyWords, setKeyWords] =
        useState<DocumentKeyWord[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        if (!dataLoaded)
            getAllData();
    }, []);

    const parts = window.location.href.split('/');
    const documentId = parts[parts.length - 1];

    return (
        <div className="pw-form-container">
            <div className="lq-header pw-margin-top-05">
                <div className="lq-header-title">Documentation Editor</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div className="pw-form-section">
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-30">
                        <div className="pw-form-unit-label">Title</div>
                        <TextBox id="title" placeholder="na"
                            value={helpDocument && helpDocument.title ?
                                helpDocument.title : undefined}
                            onValueChanged={onValueChanged} />
                    </div>
                    <div className="title-bar-spacer" />
                    <div className="save-toolbar pw-margin-right-05">
                        <Button id="saveButton" text="Save" icon="save" type="success"
                            className="pw-button"
                            hint="save changes"
                            height={'1.8rem'}
                            onClick={onSaveClick} />

                        <Button id="cancelButton" text="Close" icon="close" type="normal"
                            className="pw-button"
                            hint="close form"
                            height={'1.8rem'}
                            onClick={onCancelClick} />
                    </div>

                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Description</div>
                    <TextBox id="description" placeholder="na" className="textbox"
                        value={helpDocument && helpDocument.description ?
                            helpDocument.description : undefined}
                        onValueChanged={onValueChanged} />
                </div>

                {helpDocument && helpDocument.formName &&
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">Form</div>
                            <div className="pw-readonly-label">{helpDocument.formName}</div>
                        </div>
                        <div className="title-bar-spacer" />
                        <div className="pw-comp-row pw-margin-top-1 pw-margin-right-1">
                            <span className="material-symbols-outlined search-item-icon pw-margin-top-02 pw-blue">
                                {helpDocument.mainDocument ? 'check_box' : 'check_box_outline_blank'}</span>
                            <div className="pw-readonly-label"> Main Document</div>
                        </div>
                    </div>
                }
            </div>

            <div id="DocumentEditorContainer" className="pw-margin-left-05" >
                <HtmlEditor height="100%"
                    value={helpDocument && helpDocument.html ? helpDocument.html : undefined}
                    onValueChanged={onEditorContentChanged}>
                    <Mention dataSource={keyWords ? keyWords : []} displayExpr="fieldName" valueExpr="fieldId" />
                    <MediaResizing enabled={true} />
                    <TableContextMenu enabled={true} />
                    <TableResizing enabled={true} />

                    <Toolbar multiline={true} >
                        <Item name="separator" />
                        <Item name="undo" />
                        <Item name="redo" />
                        <Item name="separator" />
                        <Item name="size" acceptedValues={EditorConstants.FontSizes} />
                        <Item name="font" acceptedValues={EditorConstants.FontFamilies} />
                        <Item name="separator" />
                        <Item name="bold" />
                        <Item name="italic" />
                        <Item name="strike" />
                        <Item name="underline" />
                        <Item name="separator" />
                        <Item name="alignLeft" />
                        <Item name="alignCenter" />
                        <Item name="alignRight" />
                        <Item name="alignJustify" />
                        <Item name="separator" />
                        <Item name="orderedList" />
                        <Item name="bulletList" />
                        <Item name="separator" />
                        <Item name="header" acceptedValues={EditorConstants.HtmlHeaderValues} />
                        <Item name="separator" />
                        <Item name="color" />
                        <Item name="background" />
                        <Item name="separator" />
                        <Item name="link" />
                        <Item name="image" />
                        <Item name="separator" />
                        <Item name="clear" />
                        <Item name="codeBlock" />
                        <Item name="blockquote" />
                        <Item name="separator" />
                        <Item name="insertTable" />
                        <Item name="deleteTable" />
                        <Item name="insertRowAbove" />
                        <Item name="insertRowBelow" />
                        <Item name="deleteRow" />
                        <Item name="insertColumnLeft" />
                        <Item name="insertColumnRight" />
                        <Item name="deleteColumn" />
                    </Toolbar>
                </HtmlEditor>
            </div>

            <DmaFooter />

            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                showPane={true} />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id;

        let fieldUpdate: FieldUpdate = {
            field: caller,
            value: e.value,
            integerRowId: helpDocument && helpDocument.documentId ?
                helpDocument.documentId : undefined
        };

        updateField(fieldUpdate)
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Document Field");
            });

        setHelpDocument({ ...helpDocument, [caller]: e.value })
    }

    function onEditorContentChanged(e: any) {
        //this is needed because what seems to be a DE bug- if the event is undefined/null then it is not
        // a legit event firing
        if (!e.event)
            return;

        setHelpDocument({ ...helpDocument, html: e.value });
    }

    // get functions

    async function getHelpDocument() {
        await CrudFunctions.getData(`documentation/edithelpdocument/${documentId}`)
            .then(data => {

                console.log(data);

                setHelpDocument(data);
                hideLoadPanel();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Document");
            });
    }

    async function getHelpDocumentKeyWords() {
        await CrudFunctions.getData(`documentation/helpdocumentkeywords/${documentId}`)
            .then(data => {
                console.log(data);

                setKeyWords(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Document");
            });
    }



    //PUT functions

    //todo: update whole document in one way (not BLOB and title/description separately)
    //  and have all happen from Save button

    async function updateHelpDocument(helpDocument: HelpDocument) {
        return CrudFunctions.putData("documentation/helpdocumentblob", helpDocument);
    }

    async function updateField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("documentation/helpdocumentfield", fieldUpdate);
    }

    // DELETE functions

    async function deleteHelpDocument(documentId: number) {
        return CrudFunctions.deleteData(`documentation/helpdocument/${documentId}`);
    }

    //navigation

    function goBack() {
        history.back();
    }

    function onSaveClick(e: any) {
        saveChanges();
    }

    function onCancelClick(e: any) {
        history.back();
    }

    function hideLoadPanel() {
        setLoadPanelVisible(false);
    }

    function saveChanges() {
        updateHelpDocument(helpDocument)
            .then(() => {
                getHelpDocument();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Document");
            });
    }

    async function getAllData() {
        await Promise.all([
            getHelpDocument(),
            getHelpDocumentKeyWords()
        ])
            .then(() => setDataLoaded(true));
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

